import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { tv, type VariantProps } from 'tailwind-variants';

import { IconComponent } from '../icon/icon';

export const badge = tv({
  base: 'badge px-1.5 gap-0-5 py-0',
  compoundVariants: [
    {
      class: 'bg-i-surface-accent-soft!',
      intent: 'accent',
      soft: true,
    },
  ],
  defaultVariants: {
    intent: 'neutral',
    size: 'sm',
    soft: false,
  },
  variants: {
    intent: {
      accent: 'badge-accent',
      error: 'badge-error',
      info: 'badge-info',
      neutral: 'badge-neutral',
      primary: 'badge-primary',
      secondary: 'badge-secondary',
      success: 'badge-success',
      warning: 'badge-warning',
    },
    size: {
      md: 'h-5 text-xs font-semibold px-1',
      // leading-4 must follow the font size, which tailwind-merge treats as overriding it.
      sm: 'h-4-5 text-2xs leading-4',
    },
    soft: {
      true: 'badge-soft',
    },
  },
});
export type BadgeVariants = VariantProps<typeof badge>;
export type BadgeIntent = NonNullable<BadgeVariants['intent']>;
export type BadgeSize = NonNullable<BadgeVariants['size']>;

@Component({
  selector: 'app-badge',
  imports: [IconComponent],
  templateUrl: './badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  readonly label = input<string>();
  readonly icon = input<IconProp>();
  readonly intent = input<BadgeIntent>('neutral');
  readonly size = input<BadgeSize>('sm');
  readonly soft = input(false);

  readonly classes = computed((): string =>
    badge({
      intent: this.intent(),
      size: this.size(),
      soft: this.soft(),
    })
  );
}
